(() => {
  if (customElements.get('ege-drawer-invoice')) return;

  const keys = [
    'Fatura türü',
    'Şirket unvanı',
    'Vergi dairesi',
    'Vergi numarası'
  ];

  const state = {
    values: null,
    timer: null,
    queue: Promise.resolve(),
    busy: false
  };

  function save(values) {
    const snapshot = { ...values };

    const request = state.queue.catch(() => {}).then(async () => {
      const root = window.Shopify?.routes?.root || '/';

      const response = await fetch(`${root}cart/update.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ attributes: snapshot })
      });

      if (!response.ok) {
        throw new Error('Fatura bilgileri kaydedilemedi.');
      }

      await response.json();
    });

    state.queue = request;
    return request;
  }

  customElements.define(
    'ege-drawer-invoice',
    class extends HTMLElement {
      connectedCallback() {
        this.fields = [
          ...this.querySelectorAll('[data-invoice-key]')
        ];

        if (!state.values) {
          state.values = {};

          this.fields.forEach((field) => {
            state.values[field.dataset.invoiceKey] = field.value;
          });
        }

        this.fields.forEach((field) => {
          field.value = state.values[field.dataset.invoiceKey] || '';
        });

        this.toggleCompany();

        this.onEdit = () => {
          this.readValues();
          this.toggleCompany();
          this.showError('');

          clearTimeout(state.timer);

          state.timer = setTimeout(() => {
            save(state.values).catch(() => {
              const current = document.querySelector(
                '#CartDrawer ege-drawer-invoice'
              );

              current?.showError(
                'Bilgiler kaydedilemedi. Ödemeye geçerken yeniden denenecek.'
              );
            });
          }, 400);
        };

        this.addEventListener('input', this.onEdit);
        this.addEventListener('change', this.onEdit);
      }

      disconnectedCallback() {
        this.removeEventListener('input', this.onEdit);
        this.removeEventListener('change', this.onEdit);
      }

      readValues() {
        this.fields.forEach((field) => {
          state.values[field.dataset.invoiceKey] = field.value;
        });

        if (state.values['Fatura türü'] !== 'Kurumsal') {
          keys.slice(1).forEach((key) => {
            state.values[key] = '';
          });
        }
      }

      toggleCompany() {
        const isCompany =
          state.values['Fatura türü'] === 'Kurumsal';

        this.querySelector('[data-invoice-company]').hidden =
          !isCompany;

        this.fields.forEach((field) => {
          if (field.dataset.invoiceKey === 'Fatura türü') return;

          field.required = isCompany;
          field.setCustomValidity('');

          if (!isCompany) field.value = '';
        });
      }

      showError(message) {
        const error = this.querySelector('[data-invoice-error]');
        error.textContent = message;
        error.hidden = !message;
      }

      validate() {
        this.readValues();

        if (state.values['Fatura türü'] !== 'Kurumsal') {
          return true;
        }

        const invalidField = this.fields.find((field) => {
          if (field.dataset.invoiceKey === 'Fatura türü') {
            return false;
          }

          return !field.value.trim();
        });

        if (!invalidField) return true;

        this.querySelector('details').open = true;
        invalidField.setCustomValidity('Lütfen bu alanı doldurun.');
        invalidField.reportValidity();
        invalidField.focus();
        return false;
      }
    }
  );

  let allowedForm = null;

  document.addEventListener('submit', async (event) => {
    const form = event.target;

    if (form.id !== 'CartDrawer-Form') return;

    if (allowedForm === form) {
      allowedForm = null;
      return;
    }

    const invoice = document.querySelector(
      '#CartDrawer ege-drawer-invoice'
    );

    if (!invoice) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    if (state.busy || !invoice.validate()) return;

    const submitter =
      event.submitter ||
      document.getElementById('CartDrawer-Checkout');

    if (!submitter) return;

    clearTimeout(state.timer);
    state.busy = true;
    submitter.disabled = true;

    try {
      await save(state.values);

      const currentForm = document.getElementById('CartDrawer-Form');
      const currentButton =
        document.getElementById('CartDrawer-Checkout');

      if (!currentForm || !currentButton) {
        throw new Error('Sepet güncellendi. Lütfen tekrar deneyin.');
      }

      currentButton.disabled = false;
      allowedForm = currentForm;
      currentForm.requestSubmit(currentButton);
      allowedForm = null;
    } catch (error) {
      allowedForm = null;

      const current = document.querySelector(
        '#CartDrawer ege-drawer-invoice'
      );

      if (current) {
        current.querySelector('details').open = true;
        current.showError(
          'Fatura bilgileri kaydedilemedi. Lütfen tekrar deneyin.'
        );
      }
    } finally {
      state.busy = false;

      if (submitter.isConnected) {
        submitter.disabled = false;
      }
    }
  }, true);
})();
